import React, { useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation, useParams } from "react-router-dom";
import { articlesData } from "../Pages/Articles/articlesData";
import { getArticleSeo, getSeoForPath, SITE_NAME, SITE_URL } from "../seo/siteSeo";

const PageSeo = () => {
  const { pathname } = useLocation();
  const { slug } = useParams();

  const seo = useMemo(() => {
    if (pathname.startsWith("/articles/") && slug) {
      const article = articlesData.find((item) => item.slug === slug);
      return getArticleSeo(article);
    }
    return getSeoForPath(pathname);
  }, [pathname, slug]);

  const canonicalUrl = `${SITE_URL}${seo.canonicalPath || pathname}`;
  const ogImage = seo.ogImage || `${SITE_URL}/UrbanBrew_Logo_Blue.png`;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={seo.ogType || "website"} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default PageSeo;
